import React from "react";
import "./pray-now-banner.styles.css";

const PrayNowBanner = () => {
  return (
    <>
      <div className="pray-now-banner">
        <div className="pray-now-text-container">
          <div>
            <h1 className="pray-now-text">ADD A PRAYER</h1>
          </div>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="2.5em"
            viewBox="0 0 512 512"
          >
            <g fill="#F4E8D4">
              <path d="M470.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 256 265.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160zm-352 160l160-160c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 256 73.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0z" />
            </g>
          </svg>
          <div>
            <h1 className="pray-now-text">HOPECITYEDINBURGH.ORG/PRAY</h1>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrayNowBanner;
